import { render } from "./WalineComment.vue?vue&type=template&id=dbcaf9ac&scoped=true"
import script from "./WalineComment.vue?vue&type=script&lang=js"
export * from "./WalineComment.vue?vue&type=script&lang=js"

import "./WalineComment.vue?vue&type=style&index=0&id=dbcaf9ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbcaf9ac"]])

export default __exports__